module.exports = __webpack_public_path__ + "img/logo.ee2ba240.jpg";